import { render, staticRenderFns } from "./c_kokart_resim.vue?vue&type=template&id=534fb3d0"
import script from "./c_kokart_resim.vue?vue&type=script&lang=js"
export * from "./c_kokart_resim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports